import React from "react";
import { Accordion } from "../../../../../../react-core/Html/Accordion";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { SelectEditor } from "../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../react-core/Html/TextBoxEditor";
import { Email } from "../../../../../../react-core/Html/Validation/RegExPatterns";
import { EmailFrequency } from "../../../../../../Wrap/Constants/Enums/Notification/EmailFrequency";
import { NotificationEmailConfiguration } from "../../../../../../Wrap/Models/Domains/Threads/NotificationEmailConfiguration";
import { ValidatorContents } from "../../../../Common/ValidatorHelper";
import { UserStore } from "../../../../Stroes/Variable";
import { NotificationAction } from "../../Action/NotificationAction";
import { EmailFrequencyMap, EmailFrequencyOptions } from "../../Resource/Content";
import { AlertDefinitionCategory } from "../../../../../../Wrap/Models/Domains/Threads/AlertDefinitionCategory";
import { NotificationConfigurationModel } from "../../../../../../Wrap/Models/Domains/Threads/NotificationConfigurationModel";
import { NotificationConfiguration } from "../../../../../../Wrap/Models/Domains/Threads/NotificationConfiguration";
import { CheckboxEditor } from "../../../../../../react-core/Html/CheckboxEditor";
import { UserEmailAlertPreferences } from "../../../../../../Wrap/Models/Domains/Threads/UserEmailAlertPreferences";

interface IEmailNotificationProps {
    model: NotificationConfigurationModel;
    emailConfig: NotificationEmailConfiguration;
    userEmailAlertPreferences: Array<UserEmailAlertPreferences>;
    onSave: () => void;
    onSaveEmailSetting: () => void;
}

interface IEmailNotificationState {
    existingConfigurations: Array<NotificationConfiguration>;
    categoriesToDelete: Array<AlertDefinitionCategory>;
    emailConfig: NotificationEmailConfiguration;
    emailAddress: string;
    userEmailAlertPreferences: Array<UserEmailAlertPreferences>;
    alertDefinitionCategories: Array<AlertDefinitionCategory>;
    alertsToRemove: Array<NotificationConfiguration>;
    showErrorMsg: boolean;
}

export class EmailNotification extends FormComponent<IEmailNotificationProps, IEmailNotificationState> {
    constructor(props: any) {
        super(props);
        this.state = {
            alertsToRemove: [],
            alertDefinitionCategories: props.model?.Categories,
            userEmailAlertPreferences: props.userEmailAlertPreferences,
            existingConfigurations: props.model?.ActiveNotifications,
            categoriesToDelete: [],
            emailConfig: props.emailConfig,
            emailAddress: UserStore.getUserInfo()?.EmailAddress,
            showErrorMsg: false,
        };
    }

    componentDidMount() {}

    private displayExistingAlertDefinition(alertName: string): JSX.Element {
        const { userEmailAlertPreferences } = this.state;
        const alertConfigs = userEmailAlertPreferences.filter((x) => x?.AlertDisplayName == alertName);
        const configuration = alertConfigs[0];
        const placeholder = "ImportantInformation";
        if (!configuration) {
            return null;
        }
        return (
            <tr>
                <td>{configuration?.CategoryName}</td>
                <td>{configuration?.AlertDisplayName}</td>
                <td className="cell-30">{configuration?.AlertType}</td>
                <td className="text-right">

                        <CheckboxEditor
                            label=""
                            onChange={(v) => {
                                const updatedUserEmailAlertPreferences = this.state.userEmailAlertPreferences.map(pref => {
                                    if (pref.AlertDisplayName === alertName) {
                                        return {...pref, ReceiveEmailAlert: v};
                                    }
                                    return pref;
                                });
                                this.setState({userEmailAlertPreferences: updatedUserEmailAlertPreferences});
                            }}
                            value={configuration?.ReceiveEmailAlert}
                            cssWrapper="square-checkbox mb-0 ml-10"
                        />

                </td>
            </tr>
        );
    }

    private displayNotificationConfigurations() {
        const { existingConfigurations } = this.state;
        const rows: JSX.Element[] = [];

        if (existingConfigurations) {
            const alertDefinitions = existingConfigurations.map((x) => x.Alert);
            const distinctAlerts = alertDefinitions.filter((n, i) => alertDefinitions.indexOf(n) === i);
            distinctAlerts.forEach((alert, index) => {
                rows.push(<React.Fragment key={index}>{this.displayExistingAlertDefinition(alert)}</React.Fragment>);
            });
        }

        return (
            <table className="data-table no-sided-padding mb-0 pb-24">
                <thead>
                <tr>
                    <th className="cell-30">Category</th>
                    <th className="cell-30">Notification</th>
                    <th className="cell-30">Type</th>
                    <th className="cell-30">Receive email?</th>
                </tr>
                </thead>
                <tbody>{rows}</tbody>
            </table>
        );
    }

    private onSave() {
        if (this.isValid()) {
            NotificationAction.updateNotificationEmailConfiguration(
                this.state.emailConfig,
                (result: NotificationEmailConfiguration) => {
                    this.setState({ emailConfig: result });
                    this.props.onSave();
                }
            );
        }
    }

    private onSaveEmailSetting() {
        if (this.isValid()) {
            NotificationAction.updateEmailNotificationPreferences(
                this.state.userEmailAlertPreferences,
                (result: UserEmailAlertPreferences) => {
                    this.setState({ userEmailAlertPreferences : result as UserEmailAlertPreferences[]});
                    this.props.onSaveEmailSetting();
                }
            );
        }
    }

    public render(): JSX.Element {
        const { emailConfig, emailAddress } = this.state;
       
        return (
            <div>
                <h2>Email notifications</h2>
                <span>Receive mandatory email alerts and an email summary of unread event notifications </span>
                <br />
                {this.displayNotificationConfigurations()}
                <div className="col-12 col-sm-fluid col-max-245">
                    <button
                        className="next-button"
                        onClick={() => {
                            this.onSaveEmailSetting();
                        }}
                    >
                        <span className="text">Save email</span>
                    </button>
                </div>
                <br />
                <p>
                    <span className="mr-5">Destination email address: </span>
                    <b>{emailAddress}</b>
                </p>
                <Accordion label="Add additional email recipients" cssWrapper="add-button mb-5" isOpen={false}>
                    <TextBoxEditor
                        disabled={false}
                        label="Additional Email address 1"
                        value={emailConfig?.EmailAddress1}
                        onChange={(v) => {
                            const config = this.state.emailConfig;
                            config.EmailAddress1 = v;
                            this.setState({ emailConfig: config });
                        }}
                        regex={{ errorMessage: ValidatorContents.InvalidEmail, value: Email }}
                        validationRules={[
                            {
                                errorMessage: "Cannot enter duplicate email addresses",
                                validator: (v) => v != emailAddress
                                && (v != emailConfig?.EmailAddress2
                                || emailConfig.EmailAddress2 == ""),
                            },
                        ]}
                    />
                    <TextBoxEditor
                        disabled={false}
                        label="Additional Email address 2"
                        value={emailConfig?.EmailAddress2}
                        onChange={(v) => {
                            const config = this.state.emailConfig;
                            config.EmailAddress2 = v;
                            this.setState({ emailConfig: config });
                        }}
                        regex={{ errorMessage: ValidatorContents.InvalidEmail, value: Email }}
                        validationRules={[
                            {
                                errorMessage: "Cannot enter duplicate email addresses",
                                validator: (v) => v != emailAddress
                                && (v != emailConfig?.EmailAddress1
                                || emailConfig.EmailAddress1 == ""),
                            },
                        ]}
                    />
                </Accordion>
                <div>
                    <span>When do you want to receive an email notification summary?</span>
                    <div className="row pb-7">
                        <div className="col-12 col-sm-fluid col-max-245">
                            <SelectEditor
                                label="Frequency"
                                options={EmailFrequencyOptions}
                                getText={(v) => {
                                    return EmailFrequencyMap[v];
                                }}
                                onChange={(v) => {
                                    const config = this.state.emailConfig;
                                    config.Frequency = v;
                                    this.setState({ emailConfig: config });
                                }}
                                selected={emailConfig?.Frequency}
                                required={"Please select a frequency"}
                                validationRules={[
                                    {
                                        errorMessage: "Please select a frequency",
                                        validator: (v) => {
                                            return v === EmailFrequency.NotSpecified ? false : true;
                                        },
                                    },
                                ]}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-12 col-sm-fluid col-max-245">
                    <button
                        className="next-button"
                        onClick={() => {
                            this.onSave();
                        }}
                    >
                        <span className="text">Save email</span>
                    </button>
                </div>
            </div>
        );
    }
}
